// Import all CSS
import './styles/base.css'

// Import modules
import { initFamilyTree } from './tree/family-tree.js'
import { checkAuth, initAuth } from './auth/auth.js'
import { initPersonList } from './person/person-list.js'
import { pingDatabase } from './utils/keepalive.js'

// Initialize the application
async function initApp() {
  // Fire a lightweight DB query on every visit so the Supabase free-tier
  // project doesn't pause after 7 days of inactivity. Fire-and-forget.
  pingDatabase()

  // Initialize authentication handlers
  initAuth()

  // Check authentication status
  await checkAuth()
  
  // Wait for family tree rendering
  await initFamilyTree()

  // Initialize person list handlers
  initPersonList()
  
  
}

// Start the app when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp)
} else {
  initApp()
}
